import { call } from "../helpers/axiosInterceptor";

const getAllStudentProfiles = async () => {
  try {
    const { data } = await call.get("user", {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      },
    });

    return data;
  } catch (e) {
    
  }
};

const createAssessment = async (payload: any) => {
  try {
    const { data } = await call.post(
      "assessment",
      {
        ...payload,
        name: payload.name,
        date: payload.date,
      },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        },
      }
    );
    return data;
  } catch (e) {
    
  }
};

const getAssessmentsByBatch = async (batchId: string) => {
  try {
    
    const response = await call.get(`assessment/batch/${batchId}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      },
    });

    

    if (response && response.data) {
      
      const assessmentData = response.data.data || response.data;
      

      if (Array.isArray(assessmentData)) {
        const transformedData = assessmentData.map((assessment) => {
          
          return {
            _id: assessment._id,
            student: {
              name: assessment.user?.name || "Unknown",
              _id: assessment.user?._id,
            },
            category: assessment.name || "N/A",
            assessmentLevel: assessment.assessment_level || "N/A",
            certificationLevel: assessment.certificate_level || "N/A",
            courseCompleted: assessment.status === "completed" || false,
            certificateUrl: assessment.certificate || null,
            reportCardUrl: assessment.reportCard || null,
          };
        });

        
        return { data: transformedData };
      } else {
        console.warn("Assessment data is not an array:", assessmentData);
        return { data: [] };
      }
    }

    console.warn("Unexpected response structure:", response);
    return { data: [] };
  } catch (e) {
    console.error("Error fetching assessments:", e);
    return { data: [] };
  }
};

const updateAssessmentStatus = async (assessmentId: string, status: string) => {
  try {
    const { data } = await call.put(
      `assessment/${assessmentId}`,
      { status },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        },
      }
    );
    return data;
  } catch (e) {
    console.error("Error updating assessment status:", e);
  }
};

/**
 * Updates an assessment with new details like certificate and report card URLs.
 * @param {string} assessmentId - The ID of the assessment to update.
 * @param {Object} updateData - The fields to update.
 */
const updateAssessment = async (assessmentId: string, updateData: { certificateUrl?: string; reportCardUrl?: string }) => {
  try {
    const response = await call.put(`assessment/${assessmentId}`, updateData, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      },
    });
    return response.data;
  } catch (e) {
    console.error("Error updating assessment:", e);
  }
};


export { getAssessmentsByBatch, updateAssessmentStatus, updateAssessment };
export { getAllStudentProfiles, createAssessment };
